document.addEventListener('DOMContentLoaded' , () =>{
    // product - js-btn-col
    if(document.querySelector('.js-btn-col')){
        let btnCol = document.querySelectorAll('.js-btn-col'),
            prdList = document.querySelectorAll('.prd-list');
        
        btnCol.forEach(function(el){
            let colToggleBtnArray = Array.from(el.parentNode.querySelectorAll('.js-btn-col'));

            el.addEventListener('click' , function(e){
                if(!el.classList.contains('on')){
                    colToggleBtnArray.forEach(function(el){
                        el.classList.remove('on');
                    });
                    el.classList.add('on');
                }

                //목록 스타일
                if(el.classList.contains('btn-col1')){
                    prdList.forEach(function(el){
                        el.className = 'prd-list prd-list--col1';
                    })
                }else{
                    prdList.forEach(function(el){
                        el.className = 'prd-list';
                    })
                }
            });
        })
    }

    // main - main-page
    if(document.querySelector('.main-page')){
        const mainVisual = new Swiper(".main-visual", {
            pagination: {
                el: ".main-visual__control",
            },
            loop: true,
            autoplay: {
                delay: 3000,
            },
        });

        const serviceList = new Swiper(".service-list", {
            slidesPerView: 'auto'
        });

        const voucherList = new Swiper(".voucher-list", {
            slidesPerView: 'auto'
        });

        const prdList = new Swiper(".prd-block-list", {
            slidesPerView: 'auto'
        });

        const reviewArea = new Swiper(".review-area", {
            pagination: {
                el: ".review-area__control",
                type: "fraction",
            },
            spaceBetween: 20,
        });
    }
});